import {
  getDisplayedPriceFromPlan,
  getPlanFromPeriod,
} from '@/hooks/query/useQueryProducts';
import { useTranslations } from '@/utils/translations';
import { type ProductView, Period } from '@heidi/commerce/contracts';
import { TypographyCaption, TypographyH1 } from '@heidi/design-system/typography';
import { useMemo } from 'react';

export interface PriceDisplayProps {
  period: Period;
  product: ProductView;
  billingText?: string;
}

export const PriceDisplay = ({ period, product, billingText }: PriceDisplayProps) => {
  const { t, locale } = useTranslations();

  const plan = getPlanFromPeriod(period, product);
  const displayPrice = getDisplayedPriceFromPlan(plan, 'month', false, locale);

  const billingCaption = useMemo(() => {
    if (billingText) return billingText;
    return period === Period.ONE_YEAR
      ? t('evidenceProTrial.upgradeModalV2.billedAnnuallyExcludeGst')
      : t('evidenceProTrial.upgradeModalV2.billedMonthlyExcludeGst');
  }, [period, t, billingText]);

  return (
    <div className="flex flex-col gap-4 sm:gap-5">
      <div className="flex flex-col gap-1">
        <div className="flex flex-row items-center gap-2">
          <TypographyH1 className="leading-none text-text-secondary">
            {displayPrice ?? '—'}
          </TypographyH1>
          <div className="flex flex-col gap-1">
            <TypographyCaption className="text-text-secondary">
              {t('evidenceProTrial.upgradeModalV2.perUserMonth')}
            </TypographyCaption>
            <TypographyCaption className="text-text-secondary">
              {billingCaption}
            </TypographyCaption>
          </div>
        </div>
      </div>
    </div>
  );
};
